<template>
  <div class="page-container">
    <el-card>
      <div slot="header">
        <span>收藏管理</span>
      </div>
      <el-table :data="list" v-loading="loading" style="width: 100%">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="userId" label="用户ID" width="100"></el-table-column>
        <el-table-column prop="productId" label="商品ID" width="100"></el-table-column>
        <el-table-column prop="productName" label="商品名称"></el-table-column>
        <el-table-column prop="createdAt" label="收藏时间" width="180"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="removeFavor(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { vpost } from "@/util/post";

export default {
  name: "FavorManage",
  data() {
    return { list: [], loading: false };
  },
  mounted() { this.fetchData(); },
  methods: {
    fetchData() {
      this.loading = true;
      vpost("/admin/favorite/listFavor").then(res => {
        if (res.code === 200) this.list = res.data || [];
      }).finally(() => this.loading = false);
    },
    removeFavor(id) {
      vpost("/admin/favorite/remove", { id }).then(res => {
        if (res.code === 200) {
          this.$message.success("删除成功");
          this.fetchData();
        }
      });
    }
  }
};
</script>
